import React, { useState, useEffect, useRef } from 'react'
import Modal from 'react-modal'
import { Editor } from '@tinymce/tinymce-react';

function HeaderTrackingModal({ isOpen, closeModal, handleHeaderScript }) {
  const [headerData, setHeaderData] = useState(null)
  const editorRef = useRef()
  const customStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgb(0 0 0 / 80%)',
      zIndex:100,
      width:'500x',
      height:'500x',
    },
    content: {
      position: 'relative',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'500px',
      height:'500',
      overflow: 'hidden'
    },
    closeBtn:{
      position: 'absolute',
      top:0,
      right:'-1%',
      background:'transparent',
      border:'none',
      color:'red'
    }
  
    
  };

  const saveChanges = () => {
    handleHeaderScript(headerData)
    closeModal(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      contentLabel="JS Header Tracking"
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <form action="">
              <div className="mb-2 border-bottom">
                <h3>Js Header Tracking</h3>
              </div>
              <div className="data-body">
                {/* <Editor
                      apiKey="xvb4efuqq2rl9d94jli2tb8hvkydbjs9hkbqxjkzhjm44e5e"
                      onInit={(evt, editor) => editorRef.current = editor}
                      initialValue=""
                      value={headerData}
                      init={{
                        height: 200,
                        menubar: false,
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar: 'undo redo | formatselect | ' +
                          'bold italic backcolor | alignleft aligncenter ' +
                          'alignright alignjustify | bullist numlist outdent indent | ' +
                          'removeformat | help',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                      }}
                      onEditorChange={(newValue, editor) => setHeaderData(newValue)}
                    /> */}
                <textarea 
                  className="form-control" 
                  rows={8} 
                  onChange={e=> setHeaderData(e.target.value)} 
                  value={headerData}>
                </textarea>

              </div>
              <div className="pt-4 d-flex justify-content-end border-top">
                <button type="button" className="mr-2 btn btn-primary" onClick={() => closeModal(false) } > Cancel </button>
                <button type="button" className="btn btn-primary" onClick={saveChanges}>Save Changes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default HeaderTrackingModal
